import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '@pages/settings';

/** Einstellungen-Route (/settings) */
export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsPage,
});
